module.exports = __webpack_public_path__ + "img/coffeemaker.1b8c6de4.png";